export const availableShowFilters = [
  'all',
  'demoPublished',
  'activeTemplate',
  'sharedWithCurrentUser',
];
export const DEFAULT_CHECKED_SHOW_FILTERS = ['all', 'sharedWithCurrentUser'];
export const DATA_CENTER_FILTERS = ['LON', 'SNG', 'RTP', 'SJC', 'SYD'];
export const SEARCH_TEXT_MIN_LENGTH = 3;
